import { useBrands } from "./Yachts";

const TAGLINES = ["Pan-India", "Indian Waters", "The Riviera of the East"];

export default function Marquee() {
  const { data: brands = [] } = useBrands();
  const items = [...brands.map((b) => b.name), ...TAGLINES];
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-navy-ink/10 bg-navy py-7"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track items-center gap-0">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center whitespace-nowrap">
                <span className="px-8 font-serif text-base italic tracking-wide text-gold/70 sm:text-lg">
                  {item}
                </span>
                <span className="h-1 w-1 rotate-45 bg-gold/30" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
